function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#31D055;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32.5,4.44L47.56,19.5H32.5V4.44z M2.6,61.46V14.3V2.6h27.3v19.5h19.5v1.3v38.06H2.6z M52,64.55V26v-2.6v-3.14 l-0.64-0.64c0,0,0,0,0,0l-9.48-9.48L31.74,0H0v14.3v2.6v47.65H52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,22.1h13c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3h-13c-0.72,0-1.3,0.58-1.3,1.3 C9.1,21.52,9.68,22.1,10.4,22.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,13h13c0.72,0,1.3-0.58,1.3-1.3s-0.58-1.3-1.3-1.3h-13c-0.72,0-1.3,0.58-1.3,1.3S9.68,13,10.4,13z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,31.2h31.2c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3H10.4c-0.72,0-1.3,0.58-1.3,1.3 C9.1,30.62,9.68,31.2,10.4,31.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,39.2h31.2c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3H10.4c-0.72,0-1.3,0.58-1.3,1.3 C9.1,38.62,9.68,39.2,10.4,39.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,47.2h31.2c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3H10.4c-0.72,0-1.3,0.58-1.3,1.3 C9.1,46.62,9.68,47.2,10.4,47.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M10.4,55.2h31.2c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3H10.4c-0.72,0-1.3,0.58-1.3,1.3 C9.1,54.62,9.68,55.2,10.4,55.2z"
}));

var SvgFile = function SvgFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 64.55",
    style: {
      enableBackground: "new 0 0 52 64.55"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/File.caebedbd.svg";
export { ForwardRef as ReactComponent };